//  Images Import
import Stylo from "../all images/Else Pics/stylo.png";
import Gourmet from "../all images/Gourmet Foods/Logo.png";
import HBL from "../all images/Else Pics/hbl bank.png";
import Khaadi from "../all images/Khaadi/Logo.png";
import National from "../all images/National Foods/Logo.jpg";
import PEL from "../all images/Pak Elektron Limited (PEL)/Logo.png";
import System from "../all images/Else Pics/system ltd.jpg";
import MartinDow from "../all images/Martin Dow/Logo.jpg";

const PopularBrandInfo = [
    { name: "National Foods", categery: "Grocery & Foods", img_src: National, },
    { name: "Khaadi", categery: "Clothing", img_src: Khaadi, },
    { name: "Stylo", categery: "Footwear", img_src: Stylo, },
    { name: "System ltd", categery: "IT Sevices", img_src: System, },
    { name: "Pak Elektron Limited", categery: "Electronics", img_src: PEL, },
    { name: "HBL", categery: "Banking", img_src: HBL, },
    { name: "Gourmet", categery: "Foods & Beverage", img_src: Gourmet, },
    { name: "Martin Dow", categery: "Pharmaceutical", img_src: MartinDow, },
];

export default PopularBrandInfo;